import { GameApp } from './GameApp.js';

const game = new GameApp();
game.start();
